/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Modal,
  Row,
  Col,
  Spin,
  Button,
  Select,
  Card,
  Divider,
  Space,
  Tabs,
} from 'antd';
const { TabPane } = Tabs;
import { CheckCircleOutlined } from '@ant-design/icons';
import { Button as CSButton } from '../../components';
import SearchBox from '../../components/searchbox';
import Print from '../../assets/images/Print.png';
import Export from '../../assets/images/export.png';
import ResponseDialog from '../ResopnseDialog';
import ProgressBar from '../charts/progress';
import HealthCheckListView from '../HealthCheckListView';
import BrandActions from '../../redux/middleware/brands';
import CompanyActions from '../../redux/middleware/company';
import HealthCheckActions from '../../redux/middleware/healthCheck';
import Logo from '../../assets/svg/logo.svg';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import logo from '../../assets/svg/logo.svg';
import './style.scss';

interface CategoryScore {
  score: string;
  rating: string;
  description: string;
}

type Props = {
  handleCancel: any;
  open: boolean;
  component?: string;
};

interface DataGapItem {
  item: string;
  status?: 'complete' | 'incomplete' | 'mostly complete';
  count?: number;
}

type HealthRating = 'EXCELLENT' | 'GOOD' | 'MODERATE' | 'CRITICAL' | 'POOR';

interface RatingDescription {
  color: string;
  description: string;
}

const HealthCheck = (props: Props) => {
  let { handleCancel, open } = props;
  const [loader, setLoader] = useState(false);
  const [companies, setCompanies] = useState<any>([]);
  const [companyId, setCompanyId] = useState<any>(null);
  const [companyName, setCompanyName] = useState<any>();
  const [brands, setBrands] = useState<any>([]);
  const [brandName, setBrandName] = useState<any>();
  const [brandId, setBrandId] = useState<any>();
  const [healthCheckData, setHealthCheckData] = useState<any>();
  const [healthDataGAPS, setHealthDataGAPS] = useState<any>();
  const [activeTab, setActiveTab] = useState('1');

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (brandId) {
      getHealthCheck(brandId);
    }
  }, [brandId]);

  useEffect(() => {
    if (companyId) {
      getBrand();
    }
  }, [companyId]);

  const getCompany = async () => {
    setLoader(true);
    const data = await CompanyActions.getCompany(1000, 1, [5, 7]);
    setCompanies(data?.data?.items);
    // setCompanyId(data.data.items[0].id);
    setLoader(false);
  };

  const getBrand = async () => {
    setLoader(true);
    if (!companyId) return;
    const data = await BrandActions.getCompanyBrands(companyId, 1000, 1, '');
    if (data == undefined || !data?.success) {
      setBrands([]);
    } else {
      setBrands(data?.data?.items);
      // setBrandId(data.data.items[0].brand_id);
    }
    setLoader(false);
  };

  const getHealthCheck = async (id: number) => {
    setLoader(true);
    if (!brandId) return;
    const response = await HealthCheckActions.getHealthCheck(id);
    if (response?.status) {
      setHealthCheckData(response?.data);
      setHealthDataGAPS(response?.data?.dataGapsBreakdown);
    } else {
      setHealthCheckData([]);
    }
    setLoader(false);
  };

  const onSearch = async () => {};

  // const exportToPDF = async () => {
  //   setLoader(true);
  //   try {
  //     const modalContent = document.querySelector('.ant-modal-content');
  //     if (!modalContent) return;
  //     const clone = modalContent.cloneNode(true) as HTMLElement;
  //     clone.classList.add('pdf-export-mode');
  //     const tempContainer = document.createElement('div');
  //     tempContainer.style.position = 'absolute';
  //     tempContainer.style.left = '-9999px';
  //     tempContainer.appendChild(clone);
  //     document.body.appendChild(tempContainer);
  //     const canvas = await html2canvas(clone, {
  //       scale: 2,
  //       logging: false,
  //       useCORS: true,
  //       allowTaint: true,
  //     });
  //     // Generate PDF
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const imgWidth = 210;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //     pdf.save('health-check-report.pdf');
  //     // Clean up
  //     document.body.removeChild(tempContainer);
  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const exportToPDF = async () => {
    setLoader(true);
    try {
      const pdfContainerPage1 = document.createElement('div');
      const pdfContainerPage2 = document.createElement('div');
      const containerStyles = {
        position: 'absolute',
        left: '-9999px',
        width: '794px', // A4 width in pixels (210mm)
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        boxSizing: 'border-box',
      };

      Object.assign(pdfContainerPage1.style, containerStyles);
      Object.assign(pdfContainerPage2.style, containerStyles);

      pdfContainerPage2.style.paddingTop = '40px';

      const tableRows = Object.entries(healthCheckData?.categoryWiseScore || {})
        .map(([category, data]) => {
          const categoryData = data as CategoryScore;
          return `
            <tr>
              <td style="padding: 8px; border: 1px solid #ddd; text-transform: capitalize;">${category
                .replace(/([A-Z])/g, ' $1')
                .replace(/Items/g, '')
                .trim()}</td>
              <td style="padding: 8px; border: 1px solid #ddd;">${
                categoryData?.score
              }</td>
              <td style="padding: 8px; border: 1px solid #ddd;">${
                categoryData?.rating
              }</td>
            </tr>
          `;
        })
        .join('');

      const dataGapsSections = Object.entries(healthDataGAPS)
        .map(([category, items]) => {
          const typedItems = items as DataGapItem[];
          if (typedItems.length === 0) return '';

          const totalItems = typedItems.reduce(
            (sum: number, item: DataGapItem) => {
              return sum + (item.count || 0);
            },
            0
          );

          const categoryName = category
            .replace(/([A-Z])/g, ' $1')
            .replace(/(?:^|\s)\S/g, (match) => match.toUpperCase())
            .replace('Items', ' Items')
            .trim();

          const itemsList = typedItems
            .map((item: DataGapItem) => {
              const isComplete =
                item.status === 'complete' || item.status === 'mostly complete';
              return `
                <li style="margin-bottom: 5px;">
                  ${isComplete ? '✓' : '✗'} 
                  <span style="color: ${
                    isComplete ? 'green' : 'red'
                  };">${item}${item.count ? ` (${item.count})` : ''}</span>
                </li>
              `;
            })
            .join('');
          return `
            <div style="margin-bottom: 15px;">
              <h2 style="color: #333;">${categoryName}</h2>
              <ul style="list-style-type: none; padding-left: 5px;">
                ${itemsList}
              </ul>
            </div>
          `;
        })
        .join('');

      const ratingDescriptions: Record<HealthRating, RatingDescription> = {
        EXCELLENT: {
          color: '#4CAF50', // green
          description:
            'Your ChefAdmin system integration is currently at an EXCELLENT health level with a score of ' +
            healthCheckData?.businessScore +
            '. This indicates Complete and high-quality data integration for your restaurant operations.',
        },
        GOOD: {
          color: '#808b96', // grey
          description:
            'Your ChefAdmin system integration is currently at a GOOD health level with a score of ' +
            healthCheckData?.businessScore +
            '. This indicates Most critical data is present with minor gaps which can be handled further to streamline your restaurant operations.',
        },
        MODERATE: {
          color: '#F4D03F', // yellow
          description:
            'Your ChefAdmin system integration is currently at a MODERATE health level with a score of ' +
            healthCheckData?.businessScore +
            '. This indicates Essential operations possible but significant optimization opportunities exist to run your restaurant operations.',
        },
        CRITICAL: {
          color: '#F39C12', // orange
          description:
            'Your ChefAdmin system integration is currently at a CRITICAL health level with a score of ' +
            healthCheckData?.businessScore +
            '. This indicates Basic operations possible but severely limited functionality to run your restaurant operations.',
        },
        POOR: {
          color: '#F44336', // red
          description:
            'Your ChefAdmin system integration is currently at a POOR health level with a score of ' +
            healthCheckData?.businessScore +
            ". This indicates System cannot perform core functions effectively as significant data gaps are preventing you from fully utilizing the platform's features and optimizing your restaurant operations.",
        },
      };
      const currentRating =
        healthCheckData?.rating?.toUpperCase() as HealthRating;
      const ratingInfo = ratingDescriptions[currentRating];

      // Page 1 content
      pdfContainerPage1.innerHTML = `
        <div style="text-align: center; margin-bottom: 20px;">
          <img src="${logo}" style="height: 50px; margin-right: 15px; margin-bottom: 10px;" alt="ChefAdmin Logo">
          <h1 style="color: #555; margin-top: 0; margin-bottom: 20px;">${companyName} Company</h1>
        </div>
        
        <div style="margin-bottom: 30px;">
          <h2 style="border-bottom: 1px solid #ddd; padding-bottom: 5px;">ChefAdmin Health Score Report</h2>
          <h3 style="color: #666;"><strong>Brand:</strong> ${brandName}</h3>
          <p><strong>Report Date:</strong> ${new Date().toLocaleDateString()}</p>
          <p><strong>Generated By:</strong> ChefAdmin Platform</p>
        </div>
        
        <div style="margin-bottom: 30px;">
          <h1 style="background: #f0f0f0; padding: 8px; border-left: 4px solid #666;">EXECUTIVE SUMMARY</h1>
            <div style="margin: 15px 0; padding: 10px; border-left: 4px solid ${
              ratingInfo.color
            }; background-color: #f8f8f8;">
              <h4 style="margin: 0 0 5px 0; color: ${
                ratingInfo.color
              };">${currentRating}</h4>
              <p style="margin: 0;">${ratingInfo.description}</p>
            </div>
          </div>
        </div>
        
        <div style="margin-bottom: 30px;">
          <h3><strong>Overall Health Score (${
            healthCheckData?.businessScore
          })</strong></h3>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <thead>
              <tr style="background: #f0f0f0;">
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Category</th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Score</th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Status</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </div>

        <div style="margin-bottom: 20px;">
          <h1 style="background: #f0f0f0; padding: 8px; border-left: 4px solid #666;">BUSINESS IMPACT</h1>
          <p>With your current data health score, you are missing out on key benefits:</p>
          <ul style="padding-left: 20px; list-style-type: disc;">
            <li style="margin-bottom: 8px;"><strong>Cost Control:</strong> Unable to accurately track food costs</li>
            <li style="margin-bottom: 8px;"><strong>Waste Reduction:</strong> Cannot identify waste sources</li>
            <li style="margin-bottom: 8px;"><strong>Menu Engineering:</strong> Limited ability to optimize menu pricing and profitability</li>
            <li style="margin-bottom: 8px;"><strong>Inventory Management:</strong> Manual stock counting still required</li>
            <li style="margin-bottom: 8px;"><strong>Recipe Standardization:</strong> Inconsistent food quality across shifts</li>
          </ul>
          <p>Potential improvements after fixing data gaps:</p>
          <ul style="padding-left: 20px; list-style-type: disc;">
            <li style="margin-bottom: 8px;">3-5% reduction in food costs</li>
            <li style="margin-bottom: 8px;">Approximately AED 15,000-25,000 monthly savings</li>
            <li style="margin-bottom: 8px;">Reduced prep time by 30-45 minutes per shift</li>
            <li style="margin-bottom: 8px;">Improved food consistency leading to higher customer satisfaction</li>
          </ul>
        </div>
      `;

      // Page 2 content
      pdfContainerPage2.innerHTML = `  
        <!-- Dynamic DATA GAPS BREAKDOWN section --> 
        <div style="margin-bottom: 30px;">
          <h1 style="background: #f0f0f0; padding: 8px; border-left: 4px solid #666;">DATA GAPS BREAKDOWN</h1>
          ${dataGapsSections}
        </div>
      `;

      document.body.appendChild(pdfContainerPage1);
      document.body.appendChild(pdfContainerPage2);
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageHeight = pdf.internal.pageSize.getHeight();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 20; // mm
      const scale = 2;
      const canvas1 = await html2canvas(pdfContainerPage1, {
        scale,
        logging: false,
        useCORS: true,
      });
      const imgData1 = canvas1.toDataURL('image/png');
      const imgWidth = pageWidth - margin * 2;
      const imgHeight1 = (canvas1.height * imgWidth) / canvas1.width;
      pdf.addImage(imgData1, 'PNG', margin, margin, imgWidth, imgHeight1);
      pdf.addPage();
      const canvas2 = await html2canvas(pdfContainerPage2, {
        scale,
        logging: false,
        useCORS: true,
      });
      const imgData2 = canvas2.toDataURL('image/png');
      const imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
      pdf.addImage(imgData2, 'PNG', margin, margin, imgWidth, imgHeight2);
      pdf.save(
        `health-check-report-${new Date().toISOString().slice(0, 10)}.pdf`
      );
      document.body.removeChild(pdfContainerPage1);
      document.body.removeChild(pdfContainerPage2);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal
      title={
        <div className="modal-header">
          <div className="header-text">
            <div className="title font">Missing Information Report</div>
            <div className="subtitle font">
              Review incomplete recipes and update them
            </div>
          </div>
          <div className="header-buttons">
            {/* <CSButton
              text="Print"
              className="theme-button recipeBtn no-print"
              icon={
                <img
                  src={Print}
                  alt="print"
                  style={{ width: '20px', marginRight: '5px' }}
                />
              }
              handleButtonClick={printPDF}
              shape="round"
              size="middle"
            /> */}
            <CSButton
              text="Export PDF"
              className="theme-button recipeBtn no-print"
              icon={
                <img
                  src={Export}
                  alt="health"
                  style={{ width: '20px', marginRight: '5px' }}
                />
              }
              handleButtonClick={exportToPDF}
              shape="round"
              size="middle"
            />
            {/* <CSButton
              text="Export CSV"
              className="theme-button recipeBtn exportBtn no-print"
              shape="round"
              size="middle"
            /> */}
          </div>
        </div>
      }
      centered
      open={open}
      onCancel={handleCancel}
      width={980}
      footer={null}
    >
      <Spin spinning={loader} size="large" className="loaderWidthHeight">
        <div id="health-check-modal-content">
          <div className="">
            <div className="top-filters">
              <Row className="listingTopFilter health-filter">
                <Col md={24} lg={12}>
                  <div className="brand-filter-container">
                    <Select
                      className="top-bar-filter"
                      style={{ width: '40%' }}
                      placeholder="Select Company"
                      maxTagCount="responsive"
                      value={companyId}
                      onChange={(value: any) => {
                        const company = companies?.find(
                          (company: any) => company?.id === value
                        );
                        setCompanyName(company.company_name);
                        setCompanyId(value);
                      }}
                      optionFilterProp="children"
                    >
                      {companies?.map((data: any, companyIndex: number) => (
                        <Select.Option
                          value={data?.id}
                          key={companyIndex}
                          label={data.company_name}
                        >
                          {data.company_name}
                        </Select.Option>
                      ))}
                    </Select>
                    <Select
                      className="top-bar-filter"
                      style={{ width: '40%' }}
                      placeholder="Select Brand"
                      maxTagCount="responsive"
                      value={brandId}
                      onChange={(value: any) => {
                        const brand = brands?.find(
                          (brand: any) => brand?.brand_id === value
                        );
                        setBrandId(value);
                        setBrandName(brand?.name);
                      }}
                      optionFilterProp="children"
                    >
                      {brands?.map((data: any, companyIndex: number) => (
                        <Select.Option
                          value={data?.brand_id}
                          key={companyIndex}
                          label={data.name}
                        >
                          {data.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </Col>
                <Col md={24} lg={12}>
                  <div className="search-wrapper">
                    <SearchBox action={onSearch} placeholderText="Search..." />
                  </div>
                </Col>
              </Row>
            </div>
            {/* <Divider style={{ margin: '8px 0' }} /> */}
            {/* <Space style={{ padding: '18px 8px 4px' }}> */}
            <Row className="health-row1">
              <Col md={24} lg={12}>
                <Row>
                  <Col md={24} lg={12}>
                    <div className="card-section">
                      <div className="card-title-graph health-title">
                        Health Score
                      </div>
                    </div>
                    <div className="sales-amount progress-text-div">
                      <span className="large-text progress-text">
                        {healthCheckData?.businessScore}
                      </span>
                    </div>
                    <div className="progressbar-div">
                      <ProgressBar
                        data={healthCheckData?.businessScore}
                        source="healthCheck"
                      />
                    </div>
                    {/* <div className="health">
                      <CheckCircleOutlined
                        style={{
                          fontSize: '15px',
                          color: '#52c41a',
                          marginRight: '4px',
                          paddingTop: '60px',
                        }}
                      />
                      <div className="health-score-text">
                        {healthCheckData?.description}
                      </div>
                    </div> */}
                  </Col>
                  <Col md={24} lg={12}>
                    <Card className="centered-card health-card">
                      <div className="card-section">
                        <div className="card-title">Inventory Score</div>
                      </div>
                      <div className="sales-amount">
                        <span className="large-text">
                          {
                            healthCheckData?.categoryWiseScore?.inventoryItems
                              ?.score
                          }
                          <sub className="modifier-sub small-text-week health-rating">
                            {' '}
                            {
                              healthCheckData?.categoryWiseScore?.inventoryItems
                                ?.rating
                            }
                          </sub>
                        </span>
                      </div>
                      {/*    <div className="health-score-text">
                        {
                          healthCheckData?.categoryWiseScore?.inventoryItems
                            ?.description
                        }
                      </div> */}
                    </Card>
                    {/* <div className="progressbar-div">
                      <ProgressBar
                        data={healthCheckData?.businessScore}
                        source="healthCheck"
                      />
                    </div> */}
                    <div className="health">
                      <CheckCircleOutlined
                        style={{
                          fontSize: '15px',
                          color: '#52c41a',
                          marginRight: '2px',
                          // paddingTop: '60px',
                        }}
                      />
                      <div className="health-score-text">
                        {healthCheckData?.description}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col md={24} lg={12}>
                <Row>
                  <Card className="centered-card health-card">
                    <div className="card-section">
                      <div className="card-title">Menu Score</div>
                    </div>
                    <div className="sales-amount">
                      <span className="large-text">
                        {healthCheckData?.categoryWiseScore?.menuItems?.score}
                        <sub className="modifier-sub small-text-week health-rating">
                          {' '}
                          {
                            healthCheckData?.categoryWiseScore?.menuItems
                              ?.rating
                          }
                        </sub>
                      </span>
                    </div>
                  </Card>
                  <Card className="centered-card health-card">
                    <div className="card-section">
                      <div className="card-title">Recipes Score</div>
                    </div>
                    <div className="sales-amount">
                      <span className="large-text">
                        {healthCheckData?.categoryWiseScore?.recipeItems?.score}
                        <sub className="modifier-sub small-text-week health-rating">
                          {' '}
                          {
                            healthCheckData?.categoryWiseScore?.recipeItems
                              ?.rating
                          }
                        </sub>
                      </span>
                    </div>
                    <div className="sales-amount"></div>
                  </Card>
                </Row>
                <Row>
                  <Card className="centered-card health-card">
                    <div className="card-section">
                      <div className="card-title">Sub Recipes Score</div>
                    </div>
                    <div className="sales-amount">
                      <span className="large-text">
                        {
                          healthCheckData?.categoryWiseScore?.subRecipeItems
                            ?.score
                        }
                        <sub className="modifier-sub small-text-week health-rating">
                          {' '}
                          {
                            healthCheckData?.categoryWiseScore?.subRecipeItems
                              ?.rating
                          }
                        </sub>
                      </span>
                    </div>
                    <div className="sales-amount"></div>
                  </Card>
                  <Card className="centered-card health-card">
                    <div className="card-section">
                      <div className="card-title">Nutritions Score</div>
                    </div>
                    <div className="sales-amount">
                      <span className="large-text">
                        {
                          healthCheckData?.categoryWiseScore?.nutritionalValues
                            ?.score
                        }
                        <sub className="modifier-sub small-text-week health-rating">
                          {' '}
                          {
                            healthCheckData?.categoryWiseScore
                              ?.nutritionalValues?.rating
                          }
                        </sub>
                      </span>
                    </div>
                    <div className="sales-amount"></div>
                  </Card>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: '10px 0' }} />
            {healthDataGAPS?.menuItems.length > 0 && (
              <Row>
                <Col className="ing-section" md={24} lg={10}>
                  <Row>
                    <div className="">
                      <div className="card-title-graph">
                        DATA GAPS BREAKDOWN
                      </div>
                      {/* Menu Items */}
                      {healthDataGAPS?.menuItems.length > 0 && (
                        <>
                          <li className="data-gaps-category card-title gaps-title">
                            Menu Items
                          </li>
                          <ul>
                            {healthDataGAPS.menuItems.map(
                              (item: any, index: any) => (
                                <li className="gaps-list" key={index}>
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        </>
                      )}
                      {/* Recipe Items */}
                      {healthDataGAPS?.recipeItems.length > 0 && (
                        <>
                          <li className="data-gaps-category card-title gaps-title">
                            Recipe Items
                          </li>
                          <ul>
                            {healthDataGAPS.recipeItems.map(
                              (item: any, index: any) => (
                                <li className="gaps-list" key={index}>
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        </>
                      )}
                      {/* Sub Recipe Items */}
                      {healthDataGAPS?.subRecipeItems.length > 0 && (
                        <>
                          <li className="data-gaps-category card-title gaps-title">
                            Sub Recipe Items
                          </li>
                          <ul>
                            {healthDataGAPS.subRecipeItems.map(
                              (item: any, index: any) => (
                                <li className="gaps-list" key={index}>
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        </>
                      )}
                    </div>
                  </Row>
                </Col>
                <Col className="ing-section" md={24} lg={10}>
                  <Row>
                    <div className="data-gaps">
                      {/* Inventory Items */}
                      {healthDataGAPS?.inventoryItems.length > 0 && (
                        <>
                          <li className="data-gaps-category card-title gaps-title">
                            Inventory Items
                          </li>
                          <ul>
                            {healthDataGAPS.inventoryItems.map(
                              (item: any, index: any) => (
                                <li className="gaps-list" key={index}>
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        </>
                      )}
                      {/* Nutritional Information */}
                      {healthDataGAPS?.nutritionalInformation.length > 0 && (
                        <>
                          <li className="data-gaps-category card-title">
                            Nutritional Information
                          </li>
                          <ul>
                            {healthDataGAPS.nutritionalInformation.map(
                              (item: any, index: any) => (
                                <li className="gaps-list" key={index}>
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        </>
                      )}
                    </div>
                  </Row>
                </Col>
              </Row>
            )}
            {/* <Divider style={{ margin: '10px 0' }} />
            <Row>
              <Col className="ing-section" md={24} lg={8}>
                <Row>
                  <div className="">
                    <div className="">INGREDIENTS</div>
                  </div>
                  <div className="stepThreeSubContainer healthContainerTwo">
                    <div className="stepThreeadditonal section-two-subheading">
                      <div>Total</div>
                      <div>Used</div>
                      <div>Unused</div>
                    </div>
                    <div className="stepThreeunitContainer">
                      <div className="stepThreeborderContainer">
                        <div className="stepThreeunitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={calory ? Math.round(Number(calory)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={carb ? Math.round(Number(carb)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={fat ? Math.round(Number(fat)) : ''}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col className="ing-section" md={24} lg={8}>
                <Row>
                  <div className="">
                    <div className="">SUB RECIPES</div>
                  </div>
                  <div className="stepThreeSubContainer">
                    <div className="stepThreeadditonal section-two-subheading">
                      <div>Total</div>
                      <div>Used</div>
                      <div>Unused</div>
                    </div>
                    <div className="stepThreeunitContainer">
                      <div className="stepThreeborderContainer">
                        <div className="stepThreeunitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={calory ? Math.round(Number(calory)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={carb ? Math.round(Number(carb)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={fat ? Math.round(Number(fat)) : ''}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col md={24} lg={6}>
                <Row>
                  <div className="">
                    <div className="">NUTRITIONS</div>
                  </div>
                  <div className="stepThreeSubContainer">
                    <div className="stepThreeadditonal nut-div">
                      <div>Present</div>
                      <div>Absent</div>
                    </div>
                    <div className="stepThreeunitContainer">
                      <div className="stepThreeborderContainer nut-present">
                        <div className="stepThreeunitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={calory ? Math.round(Number(calory)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={carb ? Math.round(Number(carb)) : ''}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col md={24} lg={17}>
                <Row>
                  <div className="stepThreeSubContainer recipeContainer">
                    <div className="">
                      <div className="">RECIPES</div>
                    </div>
                    <div className="stepThreeadditonal section-two-subheading">
                      <div>Total</div>
                      <div>Description Missing</div>
                      <div>Image Missing</div>
                      <div>Steps Missing</div>
                      <div>Prep Time Missing</div>
                    </div>
                    <div className="stepThreeunitContainer">
                      <div className="stepThreeborderContainer">
                        <div className="stepThreeunitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={calory ? Math.round(Number(calory)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={carb ? Math.round(Number(carb)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={fat ? Math.round(Number(fat)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={fat ? Math.round(Number(fat)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={fat ? Math.round(Number(fat)) : ''}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col md={24} lg={6}>
                <Row>
                  <div className="stepThreeSubContainer">
                    <div className="">
                      <div className="">ALLERGENS</div>
                    </div>
                    <div className="stepThreeadditonal nut-div">
                      <div>Present</div>
                      <div>Absent</div>
                    </div>
                    <div className="stepThreeunitContainer">
                      <div className="stepThreeborderContainer nut-present">
                        <div className="stepThreeunitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={calory ? Math.round(Number(calory)) : ''}
                          />
                        </div>
                      </div>
                      <div className="borderContainer">
                        <div className="unitSubContainer">
                          <input
                            className="gramValue"
                            placeholder="0"
                            type={'number'}
                            // value={carb ? Math.round(Number(carb)) : ''}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col lg={24} className="dashboardTabContainer">
                <Tabs
                  defaultActiveKey="1"
                  onChange={(key) => setActiveTab(key)}
                >
                  <TabPane key="1" tab="Inventory">
                    <HealthCheckListView activeTab={activeTab} />
                  </TabPane>
                  <TabPane key="2" tab="Recipe">
                    <HealthCheckListView activeTab={activeTab} />
                  </TabPane>
                </Tabs>
              </Col>
            </Row> */}
          </div>
          <div className="butonGroup">
            <div className="wizard-button" onClick={() => handleCancel(false)}>
              Cancel
            </div>
            {/* <div className="continue wizard-button" onClick={handleSubmit}>
              Confirm & Update Inventory
            </div> */}
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default HealthCheck;
